export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./index.vue?vue&type=template&id=7ad9b68e&scoped=true"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/games/index.vue?vue&type=template&id=7ad9b68e&scoped=true
// module id = 7OtM
// module chunks = 0